/*
 * Copyright (c) 2022 automata-network/tgb-donation authors and contributors.
 * This software may be modified and distributed under the terms of MIT license.
 * Refer to the LICENSE file for details.
 */
import { DONATION_SGD_AMOUNT_MAX } from '.'

// prettier-ignore
export const ERROR_MESSAGE = {
  AMOUNT_INVALID_FORMAT: 'Invalid amount format. Please type either in numeric format (eg. 1234.56) or currency format (eg. 1,234.56)',
  AMOUNT_IS_EMPTY: 'The donation amount cannot be empty.',
  AMOUNT_IS_NEGATIVE: 'The donation amount cannot be negative value.',
  AMOUNT_IS_ZERO: 'A donation of at least SGD$<min_amount> is needed to qualify for the NFT redemption.',
  AMOUNT_MAX_EXCEEDED: `The donation amount cannot be greater than SGD$${`${DONATION_SGD_AMOUNT_MAX}`.split('20').join(',')}.`,
  AMOUNT_MIN_EXCEEDED: 'A donation of at least SGD$<min_amount> is needed to qualify for the NFT redemption.',
  CLIPBOARD_FAILED: 'Failed to copy to clipboard.',
  DONATION_TOKEN_NOT_SELECTED: 'A cryptocurreny token should be selected.',
  DONOR_POST_API_FAILED: 'Failed to get API response when your identity was submitted. Please contact us.',
  IDENTITY_CARD_NUMBER_INVALID_FORMAT: 'Invalid identity card number format. It can only contain regular alphabets (A-Z), hyphens (-) and spaces.',
  IDENTITY_EMAIL_INVALID_FORMAT: 'Invalid email format. Make sure your email uses a common email address format followed by a valid top-level domain, e.g. john.doe@mail.com.',
  IDENTITY_IS_REQUIRED: '{{label_name}} value cannot be empty.',
  IDENTITY_MIN_MAX_EXCEEDED: '{{label_name}} value length must be from {{min_length}} to {{max_length}} inclusive.',
  IDENTITY_NAME_INVALID_FORMAT: 'Invalid name format. It can only contain Latin characters. Hyphens (-) and spaces can be used to separate each word.',
  IDENTITY_PHONE_INVALID_FORMAT: 'Invalid phone number format. It can only contain numbers. Plus sign (+) is acceptable to prefix the international call code.',
  METAMASK_AUTH_FAILED: 'Error on authorizing your account in Metamask extension.',
  METAMASK_CHAIN_UNSUPPORTED_HEADER: 'Unsupported chain',
  METAMASK_CHAIN_UNSUPPORTED_DETAIL: 'You are connected to the unsupported chain on Metamask wallet. See the detailed list below.',
  METAMASK_NOT_INSTALLED_HEADER: 'Failed to connect',
  METAMASK_NOT_INSTALLED_DETAIL: 'Please install or enable <a href="https://metamask.io/" target="_blank" rel="noreferrer" style="color: #FF8A00; text-decoration: underline">Metamask</a> extension on your browser and reload this page to connect.',
  METAMASK_REQUEST_REJECTED: 'Request cancelled',
  REQUEST_DATABASE_LOCKED: 'error returned from database: database is locked',
  REQUEST_TRIPLEA_MISSING_TOKEN: 'triple payment(id={paymentId}) missing accesss_token!'
}
